import { DataProcessingService } from '@/helpers/usercentrics-helper';
import { SnowplowContext } from './snowplow-contexts';
import { TrackingProvider, TrackingProviderPropertiesInterface } from './tracking-provider';

declare global {
	interface Window {
		dataLayer: any[];
	}
}

export class TrackingProviderGoogleTagManager extends TrackingProvider {
	dataProcessingService = DataProcessingService.GOOGLE_TAG_MANAGER;

	constructor(private config: { containerId: string; doNotTrack: boolean }) {
		super();
	}

	initialize() {
		return new Promise<void>(resolve => {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			const f = document.getElementsByTagName('script')[0],
				j = document.createElement('script'),
				dl = 'dataLayer' != 'dataLayer' ? '&l=' + 'dataLayer' : '';
			j.async = true;
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.config.containerId + dl;
			f.parentNode!.insertBefore(j, f);
			resolve();
		});
	}

	async trackPage({
		path,
		title,
		permanent_audiences,
	}: {
		path?: string;
		title?: string;
		permanent_audiences?: string[];
	}) {
		// if (!this.config.doNotTrack) {
		const dataLayer = (window.dataLayer = window.dataLayer || []);
		dataLayer.push({
			event: 'content-view',
			'content-name': path,
			userId: undefined,
		});
		if (!this.config.doNotTrack) {
			if (permanent_audiences && Array.isArray(permanent_audiences) && !!permanent_audiences.length) {
				dataLayer.push({
					event: 'permanent_audiences',
					u9: permanent_audiences.join(';'),
					send_to: 'DC-5281021/s_init/justp00+standard',
				});
			}
		}
		// }
	}

	async trackEvent(category: string, properties: TrackingProviderPropertiesInterface, contexts: SnowplowContext[]) {
		// if (!this.config.doNotTrack) {
		const dataLayer = (window.dataLayer = window.dataLayer || []);
		properties = properties || {};
		dataLayer.push({
			event: 'interaction',
			target: category,
			action: properties.action,
			'target-properties': properties.label,
			value: properties.value,
			'interaction-type': properties.nonInteraction,
			userId: undefined,
		});
		// }
	}
}
